"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackToTopButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_scroll_1 = __importDefault(require("react-scroll"));
var icons_1 = __importDefault(require("../../../assets/icons"));
var scrollHooks_1 = require("../../../hooks/media/scrollHooks");
var ActionButton_1 = require("../../atoms/ActionButton/ActionButton");
var BackToTopButton_static_1 = require("./BackToTopButton.static");
var BackToTopButton_style_1 = __importDefault(require("./BackToTopButton.style"));
/**
 * BackToTopButton molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-backtotopbutton--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/BackToTopButton Source}
 */
var BackToTopButton = function (_a) {
    var sidebarCollapsed = _a.sidebarCollapsed, className = _a.className, _b = _a.minimalDistanceToDisplay, minimalDistanceToDisplay = _b === void 0 ? 1 : _b;
    var classes = (0, BackToTopButton_style_1.default)();
    var scrollYDistance = (0, scrollHooks_1.useScrollYDistance)();
    return ((0, jsx_runtime_1.jsx)(ActionButton_1.ActionButton, { isVisible: scrollYDistance >= minimalDistanceToDisplay, onClick: react_scroll_1.default.animateScroll.scrollToTop, iconPath: icons_1.default.arrowUp, name: BackToTopButton_static_1.localText.backToTop, className: (0, classnames_1.default)(className, sidebarCollapsed ? classes.buttonPositionCollapsed : classes.buttonPosition) }));
};
exports.BackToTopButton = BackToTopButton;
